module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"_","commonjs2":"lodash","commonjs":"lodash","amd":"lodash"}
 ** module id = 2
 ** module chunks = 0
 **/